module.exports = __webpack_public_path__ + "img/profil3.bb39e856.png";